<template>
    <div id="userOverlay" class="overlay">
      <div id="userModal" class="modal" v-click-outside="toggleUserModal">
        <div class="modal-header">
          <div id="loginHeader">MY ACCOUNT</div>
        </div>
        <div id="userContent" class="modal-content">
          <div id="userErrorMessage" v-if="showUserErrorMessage" v-html="userErrorMessage"></div>
          <div id="userForm">
            <div class="user-item">
              <div class="item-label">Current Password</div>
              <input id="userPassword" type="password" v-model="updatedCredentials.currentPassword" placeholder="Current Password" @input="clearError" @keydown.enter="attemptCredentialsUpdate" />
            </div>
            <div class="user-item">
              <div class="item-label">New Password</div>
              <input id="userPassword" type="password" v-model="updatedCredentials.updatedPassword" placeholder="New Password" @input="clearError" @keydown.enter="attemptCredentialsUpdate" />
            </div>
            <div class="user-item">
              <div class="item-label">Confirm New Password</div>
              <input id="userPassword" type="password" v-model="updatedCredentials.updatedPasswordConfirmation" placeholder="Confirm New Password" @input="clearError" @keydown.enter="attemptCredentialsUpdate" />
            </div>
          </div>
          <div id="userControls">
            <div id="userButton" class="game-button" :class="{'disabled': userUpdateDisabled}" @click="updateUserCredentials(updatedCredentials)">UPDATE PASSWORD</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserModal',
  components: {

  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'users',
      'showUserErrorMessage',
      'userErrorMessage',
      'currentUser',
    ]),
    userUpdateDisabled(){
      const theUserModal = this;
      return (theUserModal.updatedCredentials.currentPassword === '' || theUserModal.updatedCredentials.updatedPassword === '' || theUserModal.updatedCredentials.updatedPasswordConfirmation === '' || theUserModal.showUserErrorMessage)
    },
  },
  methods: {
    ...mapActions([
      'updateUserCredentials',
      'toggleUserModal',
      'toggleUserError'
    ]),
    clearError(){
      const theUserModal = this;
      if(theUserModal.showUserErrorMessage){
        theUserModal.toggleUserError({message: '', visible: false})
      }
    },
    attemptCredentialsUpdate(){
      // const theUserModal = this;
      // if(!theUserModal.userUpdateDisabled){
      //   theUserModal.updateUserCredentials(theUserModal.updatedCredentials)
      // }
      // console.log('aaaaaaaaaaaaaaaaa')
      console.log(this.updatedCredentials)
    }
  },
  mounted(){
    const theUserModal = this;
    theUserModal.updatedCredentials.id = theUserModal.currentUser.id;
  },
  beforeUnmount(){

  },
  data: function(){
    return {
      updatedCredentials: {
        id: '',
        currentPassword: '',
        updatedPassword: '',
        updatedPasswordConfirmation: '',
      }
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style>
  #userOverlay{

  }

  #userModal{

  }

  #userHeader{
    
  }

  #userContent{

  }

  #userContent.modal-content{
    overflow-y: initial; /* NOTE: THIS IS SET TO auto EVERYWHERE ELSE TO ALLOW FOR SCROLLING; THIS IS DIFFERENT HERE TO ALLOW OVERFLOW OF DROPDOWN AND SCROLL OF ALL USERS  */
  }

  #userForm{
    width: 80%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }

  #userErrorMessage{
    font-size: 20px;
    font-weight: bold;
    padding: 10px 0px;
    width: 80%;
    margin: 20px auto 10px auto;
  }

  .user-item{
    margin-top: 15px;
  }

  .user-item select, .user-item input{
    width: 100%;
    padding: 5px;
    margin: 5px auto;
  }

  .user-item input::placeholder{
    font-weight: bold;
  }

  .item-label{
    text-align: left;
    font-weight: bold;
    font-size: 20px;
  }

  #userControls{
    width: 100%;
    max-width: 200px;
    margin-top: 20px;
    margin: 10px auto;
  }

  #userButton{
    font-size: 24px;
    transition: all 0.25s;
  }
  #userButton:hover{
    cursor: pointer;
  }

  #userButton.disabled{
    pointer-events: none;
    background-color: rgba(51, 51, 51, 0.4);
    color: rgba(255, 255, 255, 0.4);
  }
</style>